module.exports = __webpack_public_path__ + "img/Bg.bafc34b6.png";